/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, Suspense, lazy } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import axios from "axios";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Install from "./pages/Install";
import { bindTeamsData, bindTheme } from "./store/donationSlice";
import CryptoJS from "crypto-js";
import Protected from "./pages/Protected";
import Loading from "./pages/Loading";
import PublishForm from "./pages/PublishForm";
import { SALT_KEY, API_BASE_URL } from "./utility/constants";
import Success from "./pages/Success";
import { extractEmailParts, getAttributeValue } from "./utility/util";
import InvitationModal from "./pages/InvitationModal";
import ConfigPage from "./pages/Config";
import AuthPage from "./pages/Auth";
import MobileInvite from "./pages/MobileInvitation";
import RemoveTab from "./pages/RemoveTab";

const HostPage = lazy(() => import("./pages/HostLanding"));
const UserPage = lazy(() => import("./pages/UserDonationHome"));



const App = () => {
  const [hasadminconsent, setHasAdminConsent] = useState(false);
  const [frameContext, setFrameContext] = useState(null);
  //const [apptype, setApptype] = useState(null);
  const [meetingId, setMeetingId] = useState(null);
  const [userinfo, setUserInfo] = useState({});
  const [useraccountinfo, setUserAccountInfo] = useState({});
  const [meetingUUID, setMeetingUUID] = useState("");
  const [chatId, setChatId] = useState("");
  const [appoutofcontext, setAppOutOfContext] = useState(false);
  const [isExistingForm, setIsExistingForm] = useState(false);
  const [checkFormExists, setCheckFormExists] = useState("");
  const [appinbrowser, setAppInBrowser] = useState(false);
  const [appcontext, setAppRunningContext] = useState(false);
  const [versionNumber, setVersionNumber] = useState("");
  const [serverName, setServerName] = useState("");
  const [clientType, setClientType] = useState("");


  //const { instance, accounts, inProgress  } = useMsal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const onAllow = (token) => {
    microsoftTeams.dialog.url.submit({ message: "allow" });
  };

  const onDeny = () => {
    microsoftTeams.dialog.url.submit({ message: "deny" });
  };

  const initializeApp = () => {

     microsoftTeams.app
      .initialize()
      .then(() => {
       
        microsoftTeams.app.getContext().then(async (context) => {
  
           applyTheme(context.app.theme);
           dispatch(bindTheme(context.app.theme));
          setFrameContext(context.page?.frameContext);
          setClientType(context.app.host.clientType);
          if (context.user?.tenant?.id)
            checkAdminConsentRequired(context.user?.tenant?.id);
          if (context.meeting) {
            localStorage.setItem("chatId", context?.chat?.id);
            setChatId(context?.chat?.id);
            //Get Active subscriptions
            await getActiveSubscription(context.user?.tenant?.id);

            if (context.page?.frameContext !== "task") {
              microsoftTeams.meeting.getMeetingDetails(
                async (error, meetingDetails) => {
                  const MeetId = context.chat.id
                    .replace("19:meeting_", "")
                    .replace("19:", "")
                    .replace(/@thread.*/g, "");
                   
                  if (error) {
                    let isnotMeeting = false;
                    if (!isnotMeeting) {
                      navigate("/");
                      isnotMeeting = true;
                    }
                    //call createdb instance for 1:1 or groupcall

                    if (!sessionStorage.getItem("role") || !meetingUUID) createdbInstance(MeetId, context.user?.id, "");
                  } else {
                  
                    if (
                      meetingDetails.organizer &&
                      meetingDetails.organizer.id === context.user?.id
                    ) {
                      setUserInfo({ role: "host" });
                     // sessionStorage.setItem("role", "host");
                      if (!sessionStorage.getItem("role") || !meetingUUID) createdbInstance(MeetId, context.user?.id, "host");
                    } else {
                    
                      // Optimistically set attendee role
                      if (!sessionStorage.getItem("role")) {
                        sessionStorage.setItem("role", "Attendee");
                        setUserInfo({ role: "Attendee" });
                      } else {
                        setUserInfo({ role: sessionStorage.getItem("role") });
                      }

                      // Always ensure db instance is created in background
                      if (!meetingUUID) {
                        createdbInstance(MeetId, context.user?.id, "Attendee");
                      }
                    
                    }
                  }
                }
              );
            }

            getUserData(context);

            if (
              !isExistingForm &&
              location.pathname !== "/invite" &&
              location.pathname !== "/config"
            ) {
              setCheckFormExists("started");
              const userparams = {
                eId: sessionStorage.getItem("MID")
                  ? sessionStorage.getItem("MID")
                  : context.chat.id
                      .replace("19:meeting_", "")
                      .replace("19:", "")
                      .replace(/@thread.*/g, ""),
              };

              let postBody = CryptoJS.AES.encrypt(
                JSON.stringify({ body: { userparams } }),
                SALT_KEY
              ).toString();
              const responseformexists = await axios.post(`${API_BASE_URL}`, {
                httpMethod: "POST",
                path: "/getuserform",
                postBody,
              });

              if (
                responseformexists.data &&
                responseformexists.data.body &&
                responseformexists.data.body.Items
              ) {
             
                const guid = getAttributeValue(
                  responseformexists.data.body.Items[0].Attributes,
                  "GiventID"
                );
            
                if (guid) {
                  setIsExistingForm(true);
                  setCheckFormExists("finished");
                  navigate("/loadform", { state: { showDForm: true } });
                }
              }
              setCheckFormExists("finished");
             
            }
          } else {
         
            setAppOutOfContext(true);
          }

            microsoftTeams.app.registerOnThemeChangeHandler((theme) => {
              applyTheme(theme);
             // setTheme(theme);
              dispatch(bindTheme(theme));
            });
        });
         microsoftTeams.app.notifySuccess();
      })
      .catch((err) => {
        setAppInBrowser(true);
        setAppOutOfContext(true);
      });
     //get version number
      fetchVersionData();
  };


  useEffect(() => {
    
      initializeApp();
     
      if(sessionStorage.getItem('seedAmount') !== null && sessionStorage.getItem('seedAmount')){
           if(sessionStorage.getItem('lastBoostedSeed') !== null && sessionStorage.getItem('lastBoostedSeed')) {
              sessionStorage.setItem('seedAmount',sessionStorage.getItem('lastBoostedSeed'));
            }else{
              sessionStorage.removeItem('seedAmount');
            }
       }
     
    return () => {
      //console.log("cleaned up");
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAdminConsentRequired = async (tenantId) => {
    const params = {
      httpMethod: "POST",
      path: "/checkadminconsent",
      body: {
        tId: tenantId,
      },
    };
    const response = await axios.post(`${API_BASE_URL}`, params);
    if (response.data.body && response.data.body.appId) setHasAdminConsent(true)
    return response.data;
  };

  const getUserData = async (context) => {
    let dname = "",
      fname = "",
      lname = "";
    const userparams = {
      httpMethod: "POST",
      path: "/getuserfromgraph",
      body: {
        userId: context.user?.id,
        tId: context.user?.tenant?.id,
      },
    };
    const uresponse = await axios.post(`${API_BASE_URL}`, userparams);
    let udata;
    if (uresponse.data.body && uresponse.data.body) {
      udata = JSON.parse(uresponse.data.body);

      dname = udata.displayName;
      fname = udata.givenName;
      lname = udata.surname;
    }
    if (context.user?.userPrincipalName && !context.user?.userPrincipalName.includes("@")) dname = context.user?.userPrincipalName;
    if (!dname && context.user?.userPrincipalName && context.user?.userPrincipalName.includes("@")) {
      const parts = extractEmailParts(context.user?.userPrincipalName);
      if (parts.length > 0) {
        if (parts.length >= 2) {
          dname =
            parts[0].charAt(0).toUpperCase() +
            parts[0].slice(1) +
            " " +
            parts[1].charAt(0).toUpperCase() +
            parts[1].slice(1);
          fname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
          lname = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
        } else {
          dname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
          fname = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
        }
      }
    }
    const MeetId = context.chat.id
      .replace("19:meeting_", "")
      .replace("19:", "")
      .replace(/@thread.*/g, "");
    const teamsuserinfo = {
      email: udata.mail ? udata.mail : context.user?.userPrincipalName,
      display_name: dname,
      first_name: fname,
      last_name: lname,
      userId: context.user?.id,
      accountId: context.user?.tenant?.id,
      hostId: context.user?.id,
      meetingId: MeetId,
      startTime: new Date().toString(),
    };

    setUserAccountInfo(teamsuserinfo);

    dispatch(bindTeamsData(teamsuserinfo));
    setChatId(context?.chat?.id);
    setAppRunningContext(context.app?.host?.clientType);
    setMeetingId(MeetId);
    return;
  };
  const createdbInstance = async (mId, userId, isrole) => {
    // if(!sessionStorage.getItem("MID")){
    const params = {
      httpMethod: "POST",
      path: "/createdbinstance",
      body: {
        tableName: mId,
        uId: userId,
        isRole: isrole,
      },
    };
    const response = await axios.post(`${API_BASE_URL}`, params);

    if (response.data.body) {
      const msg = JSON.parse(response.data.body);

      if (msg.message) {
        setUserInfo({ role: msg.message });
        if(msg.mId) {
          setMeetingUUID(msg.mId);
          sessionStorage.setItem("MID", msg.mId);
        }
        sessionStorage.setItem("role", msg.message);
      }
      return;
    }
    
    // }
  };

  const getActiveSubscription = async (tenentId) => {
    const params = {
      httpMethod: "POST",
      path: "/getactivesub",
      body: {
        tId: tenentId,
      },
    };
    const response = await axios.post(`${API_BASE_URL}`, params);
    const activesub = JSON.parse(response.data.body);

    if (activesub && activesub.value) {
      if (activesub && activesub.value.length === 0)
        createSubscription(tenentId);
    }
  };

  const createSubscription = async (tenentId) => {
    const params = {
      httpMethod: "POST",
      path: "/createsubscription",
      body: {
        tId: tenentId,
      },
    };
    const response = await axios.post(`${API_BASE_URL}`, params);
    console.log("cresteSubscription==", response);
  };

  const fetchVersionData = async () => {
      try {
        const [response1, response2] = await Promise.all([
          fetch('/version.json'),
          fetch('/server.json')
        ]);

        if (!response1.ok || !response2.ok) {
          throw new Error('Failed to fetch one or more files');
        }

        const [jsonData1, jsonData2] = await Promise.all([
          response1.json(),
          response2.json()
        ]);
     
        setVersionNumber(jsonData1);
        setServerName(jsonData2);
      } catch (err) {
        console.log(err.message);
      } finally {
       // console.log("finished");
      }
    };

 const applyTheme = (theme) => {
  document.documentElement.classList.remove("dark", "contrast", "default");

  if (theme === "dark") {
    document.documentElement.classList.add("dark");
  } else if (theme === "contrast") {
    document.documentElement.classList.add("contrast");
  } else {
    document.documentElement.classList.add("default");
  }
};

const startnewGivent = () => {
    sessionStorage.removeItem('seedAmount');
    sessionStorage.removeItem('lastBoostedSeed');
    window.location.reload();
    initializeApp();
}

  return (
    <>
      <Suspense fallback={<Loading appoutofcontext={appoutofcontext} />}>
        <Routes>
          {Object.keys(useraccountinfo).length &&
            (Object.keys(userinfo).length ||
              sessionStorage.getItem("role"))  && (
              <Route
                exact
                path="/"
                element={
                  <Protected
                    isHost={
                      (Object.keys(userinfo).length
                        ? userinfo.role
                        : sessionStorage.getItem("role")) === "host"
                    }
                  >
                    {checkFormExists === "finished" && !isExistingForm ? (
                      <>
                        <HostPage
                          meetingData={meetingUUID}
                          userData={useraccountinfo}
                          appcontext={appcontext}
                          adminConsent={hasadminconsent}
                          clientType={clientType}
                          versionNumber={versionNumber}
                          serverName={serverName}
                      
                        />
                      </>
                    ) : (
                      <Loading appoutofcontext={appoutofcontext}  />
                    )}
                  </Protected>
                }
              />
            )}

          {Object.keys(useraccountinfo).length &&
            (Object.keys(userinfo).length ||
              sessionStorage.getItem("role")) && (
              <Route
                exact
                path="/tab"
                element={
                  <Protected
                    isHost={
                      (Object.keys(userinfo).length
                        ? userinfo.role
                        : sessionStorage.getItem("role")) === "host"
                    }
                  >
                    {checkFormExists === "finished" && !isExistingForm  ? (
                      <>
                        <HostPage
                          meetingData={meetingUUID}
                          userData={useraccountinfo}
                          appcontext={appcontext}
                          adminConsent={hasadminconsent}
                          clientType={clientType}
                          versionNumber={versionNumber}
                          serverName={serverName}
                        
                        />
                      </>
                    ) : (
                      <Loading appoutofcontext={appoutofcontext}  />
                    )}
                  </Protected>
                }
              />
            )}


          <Route
            exact
            path="/publishform"
            element={
              <Protected
                isHost={
                  (Object.keys(userinfo).length
                    ? userinfo.role
                    : sessionStorage.getItem("role")) === "host"
                }
              >
                <PublishForm
                  meetingData={meetingUUID}
                  userData={useraccountinfo}
                  chatId={chatId}
                  appcontext={appcontext}
                  meetingId={meetingId}
                 
                />
              </Protected>
            }
          />

    
         <Route
            exact
            path="/loadform"
            element={
              <>
              

                <UserPage
                  meetingData={meetingUUID}
                  userData={useraccountinfo}
                  ishost={
                    (Object.keys(userinfo).length
                      ? userinfo.role
                      : sessionStorage.getItem("role")) === "host"
                  }
                  versionNumber={versionNumber}
                  serverName={serverName}
                  startNewGivent={startnewGivent}
                  clientType={clientType}
                />
          
               
            </>
            }
          />
      
          

          {!Object.keys(userinfo).length && !appoutofcontext && (
            <Route
              path="/"
              element={<Loading appoutofcontext={appoutofcontext} />}
            />
          )}
          {!appinbrowser && appoutofcontext && (
            <Route
              path="/"
              element={<Loading appoutofcontext={appoutofcontext}  />}
            />
          )}
          {appinbrowser && <Route path="/" element={<Install  versionNumber={versionNumber} serverName={serverName} />} />}

          <Route path="/config" element={<ConfigPage />} />
          <Route path="/loading" element={<Loading appoutofcontext={appoutofcontext}  />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/success"
            element={<Success donateAgain={true} frameContext={frameContext} />}
          />
          <Route
            path="/invite"
            element={<InvitationModal onAllow={onAllow} onDeny={onDeny} />}
          />
          <Route path="/minvite" element={<MobileInvite chatId={chatId} />} />
          <Route path="/remove" element={<RemoveTab />} />
          <Route path="*" element={<Loading appoutofcontext={appoutofcontext}  />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
